import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="app-footer">
      <p>made with &lt;3 by lolevel</p>
    </footer>
  );
}

export default Footer;
